import ViewController from "core/views/view.controller";
import {VehiclesFilter} from "../../services/vehicles.service";
import {WheelStoragesFilter} from "../../services/wheelstorages.service";
import Customer from "../../model/customer.model";

export default class NewBookingOptionsCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicHistory', '$ionicPopup',
        '$ionicTabsDelegate', '$translate', '$modalDelegate', '$ionicScrollDelegate', '$loadingIndicator', 'settings', 'Bookings',
        'bookingProcessorSelectionModal', 'searchModalDelegate', 'customerDetailsModal', 'textModal'];

    constructor() {
        super(...arguments);

        this.bookingInProgress = false;
        this.booking = null;
        this.processors = [];
        this.processorSelection = null;

        this.defaultTitle = null;
    }

    $onViewBeforeEnter() {
        this.loadBookingState();
        this.loadDefaultTitle();
    }

    prev() {
        this.saveBookingState();
        this.$ionicHistory.goBack();
    }

    next() {
        this.saveBookingState();
    }

    loadBookingState() {
        this.booking = this.viewState('booking');

        if (!this.booking.backgroundColor && this.booking.services.length > 0) {
            this.booking.backgroundColor = this.booking.services[0].color;
        }
    }

    loadDefaultTitle() {
        if (!this.booking) {
            this.defaultTitle = null;
            return;
        }

        let services = this.booking.services;
        if (!services || services.length === 0) {
            this.defaultTitle = null;
            return;
        }

        let translate = null;

        if (services.length > 1) {
            translate = this.$translate('BOOKING_DEFAULT_SERVICES_TITLE', {
                serviceCount: services.length,
                serviceName: services[0].name
            });
        } else {
            translate = this.$translate('BOOKING_DEFAULT_SERVICE_TITLE', {
                serviceName: services[0].name
            })
        }

        translate.then(translation => {
            this.defaultTitle = translation;
        });
    }

    saveBookingState() {
        this.viewState('booking', this.booking);
    }

    editBookingDescription() {
        let self = this;

        this.textModal.show({
            title: "BOOKING_DESCRIPTION",
            text: self.booking.description,

            onSave: (text) => {
                this.booking.description = text;
            }
        })
    }

    editBookingProcessor() {
        this.bookingProcessorSelectionModal.show({
            selectedProcessor: this.booking.processor

        }).then((processor) => {
            this.booking.processor = processor;
        });
    }

    updateProcessor(processor) {
        this.booking.processor = processor;
    }

    openSearch() {
        if (this.booking.customer && this.booking.vehicle && this.booking.wheelStorage) {
            return;
        }

        let searchType = null;
        let vehiclesFilter = new VehiclesFilter();
        let wheelStoragesFilter = new WheelStoragesFilter();

        let showWheelStorageSelection = (this.booking.wheelStorage == null);
        if (showWheelStorageSelection) {
            searchType = "wheelstorages";
        }

        let showVehicleSelection = (this.booking.vehicle == null);
        if (showVehicleSelection) {
            searchType = "vehicles";
        } else {
            wheelStoragesFilter.customerId = this.booking.customer.id;
            wheelStoragesFilter.vehicleId = this.booking.vehicle.id;
        }

        let showCustomersSelection = (this.booking.customer == null);
        if (showCustomersSelection) {
            searchType = "customers";
        } else {
            vehiclesFilter.customerId = this.booking.customer.id;
            wheelStoragesFilter.customerId = this.booking.customer.id;
        }

        this.searchModalDelegate.show({
            showSearchTerm: true,
            showTypeSelection: true,
            showTypeSelectionBookings: false,
            showTypeSelectionCustomers: showCustomersSelection,
            showTypeSelectionVehicles: showVehicleSelection,
            showTypeSelectionWheelStorages: showWheelStorageSelection,
            searchType: searchType,
            searchWithoutTerm: true,
            vehiclesFilter: vehiclesFilter,
            wheelStoragesFilter: wheelStoragesFilter,

            onCustomerSelected: (customer) => {
                this.booking.customer = customer;

                if (this.booking.vehicle && this.booking.vehicle.customer.id !== customer.id) {
                    this.booking.vehicle = null;
                }

                if (this.booking.wheelStorage && this.booking.wheelStorage.customer.id !== customer.id) {
                    this.booking.wheelStorage = null;
                }
            },

            onVehicleSelected: (vehicle) => {
                this.booking.customer = vehicle.customer;
                this.booking.vehicle = vehicle;

                if (this.booking.wheelStorage && this.booking.wheelStorage.customer.id !== vehicle.id) {
                    this.booking.wheelStorage = null;
                }
            },

            onWheelStorageSelected: (wheelStorage) => {
                this.booking.customer = wheelStorage.customer;
                this.booking.vehicle = wheelStorage.vehicle;
                this.booking.wheelStorage = wheelStorage;
            },

            onSave: () => {
                this.$ionicScrollDelegate.resize();
                this.$ionicScrollDelegate.scrollBottom();
            }
        })
    }

    selectColor(color) {
        if (color) {
            this.booking.backgroundColor = color;
        } else {
            this.booking.backgroundColor = null;
        }
    }

    clearCustomer() {
        this.booking.customer = null;
        this.booking.vehicle = null;
        this.booking.wheelStorage = null;
        this.$ionicScrollDelegate.resize();
    }

    clearVehicle() {
        this.booking.vehicle = null;
        this.booking.wheelStorage = null;
        this.$ionicScrollDelegate.resize();
    }

    clearWheelStorage() {
        this.booking.wheelStorage = null;
        this.$ionicScrollDelegate.resize();
    }

    showCustomer() {
        if (!this.booking.customer) {
            return;
        }

        this.customerDetailsModal.show({
            customer: this.booking.customer,
            editable: this.booking.customer.id == null
        });
    }

    createCustomer() {
        let newCustomer = new Customer();

        this.customerDetailsModal.show({
            customer: newCustomer,
            editable: true,

            onSave: () => {
                this.booking.customer = newCustomer;
                this.$ionicScrollDelegate.resize();
                this.$ionicScrollDelegate.scrollBottom();
            },

            onCancel: () => {
                //this.booking.customer = null;
            }

        });
    }

    checkBooking() {
        // Check for booking title
        if (!this.booking.title && !this.defaultTitle) {
            this.$translate([
                'ERROR',
                'BOOKING_ERROR_NO_TITLE_MSG'
            ]).then(translations => {
                this.$ionicPopup.alert({
                    title: translations.ERROR,
                    template: translations.BOOKING_ERROR_NO_TITLE_MSG,
                    okType: 'button button-block button-stable button-outline'
                });
            });

            return false;
        }

        return true;
    }

    finishBooking() {
        if (this.bookingInProgress) {
            return;
        }

        if (!this.checkBooking()) {
            return;
        }

        this.bookingInProgress = true;

        let booking = {
            branchid: this.settings.branch.id,
            serviceid: this.booking.services.map(service => service.id).join(','),
            resourceid: this.booking.resources.map(resource => resource.id).join(','),
            duration: this.booking.duration,
            datetime: this.booking.startTime,
            title: this.booking.title,
            color: this.booking.backgroundColor,
            description: this.booking.description,
            processor: this.booking.processor ? this.booking.processor.name : null,
            ordernr: this.booking.ordernr,
            location: this.booking.location,
            sendCustomerConfirmation: this.booking.sendCustomerConfirmation
        };

        if (!booking.title) {
            booking.title = this.defaultTitle;
        }

        if (this.booking.customer) {
            booking.customer = {id: this.booking.customer.id};
        }

        if (this.booking.vehicle) {
            booking.vehicle = {id: this.booking.vehicle.id};
        }

        if (this.booking.wheelStorage) {
            booking.wheelStorage = {id: this.booking.wheelStorage.id};
        }

        this.$loadingIndicator.showErrorMessage = false;

        this.Bookings.createBooking(booking)
            .then((bookingId) => {
                this.booking = {};
                this.saveBookingState();
                this.$ionicHistory.goBack(-6);
                this.$ionicTabsDelegate.showBar(true);
            })
            .catch((error) => {
                this.handleBookingError(error);
            })
            .finally(() => {
                this.bookingInProgress = false;
                this.$loadingIndicator.showErrorMessage = false;
            })
    }

    cancel() {
        this.viewState('booking', null);
        this.$ionicHistory.goBack(-6);
        this.$ionicTabsDelegate.showBar(true);
    }

    handleBookingError(error) {
        let title = "BOOKING_ERROR_DEFAULT";
        let message = "BOOKING_ERROR_CODE";

        if (error && error.errorCode == 8) {
            title = "BOOKING_ERROR_BLOCKED";
            message = "BOOKING_SELECT_NEW_DATE";
        }

        this.$translate([title, message], {errorCode: error.errorCode})
            .then((translations) => {
                this.$ionicPopup.alert({
                    title: translations[title],
                    template: translations[message],
                    okType: 'button button-block button-stable button-outline'
                });
            });
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-options/new-booking-options.controller.js